import { useTranslation } from "@i18n";
import IconComponent from "@CubeComponents/icons";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import CreateIcon from "@Components/StickySidebarViewer/assets/CreateIcon";

interface NoMailsProps {
  readonly setOpenNewMailModal: (open: boolean) => void;
  readonly setOpenForwardModal: (open: boolean) => void;
}

function NoMails({ setOpenNewMailModal, setOpenForwardModal }: NoMailsProps) {
  const { t } = useTranslation();
  return (
    <div className="flex gap-2  flex-col h-full w-full justify-center items-center bg-white p-5">
      <IconComponent name="InspectionFormNoData" width="10rem" height="10rem" />
      <span className="text-center text-lg font-semibold">{t("No mails")}</span>
      <div data-testid="createNewMail" className="text-sm">
        <span>{t("Create a mail to get started")}</span>
      </div>
      <div className="flex gap-5">
        <ButtonComponent
          data-testid="createNewMailBtn"
          buttonType={BUTTON_TYPES.BACKGROUND_BUTTON}
          onClick={() => setOpenNewMailModal(true)}
        >
          <span className="flex flex-wrap items-center justify-start gap-2">
            <CreateIcon size="15" className="me-1" />
            {t("Create")}
          </span>
        </ButtonComponent>
        <ButtonComponent
          buttonType={BUTTON_TYPES.BACKGROUND_BUTTON}
          onClick={() => setOpenForwardModal(true)}
          data-testid="forwardMailBtn"
        >
          <span className="flex flex-wrap items-center justify-start gap-2">
            <IconComponent name="arrowRight" width="0.875rem" height="0.875rem" />
            {t("Forward")}
          </span>
        </ButtonComponent>
      </div>
    </div>
  );
}

export default NoMails;
